/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// CONTENT STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	content: {
		borderRadius: pxToEm(10),
		width: '100%',
		height: '100%',
		'& .uniquecontent': {
			borderRadius: 'inherit',
			width: '100%',
			height: '100%'
		},
        '&.editable-false': {
            pointerEvents: 'none'
        }
	}
});